// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Ypvg","paramInput":"JobSimulator_paramInput__2R5pi","input":"JobSimulator_input__37w7c"};